import Button from "@/components/button"
import { useAuthStore } from "@/store/auth"
import { Divider, Image, Radio, Row, Space, Typography } from "antd"
import React, { FC } from "react"

const PrivacyPolicyIcon = "/icons/privacy-policy.svg";
const SignOutIcon = "/icons/sign-out.svg";
const DarkTheme = "/images/dark.png";
const LightTheme = "/images/light.png";
const SystemTheme = "/images/system.png";
import { NavLink } from "react-router-dom"
import { useTernaryDarkMode } from "usehooks-ts"
import "./index.less"
type TernaryDarkMode = ReturnType<typeof useTernaryDarkMode>["ternaryDarkMode"]

const { Paragraph } = Typography
const Profile: FC = () => {
  const { ternaryDarkMode, setTernaryDarkMode } = useTernaryDarkMode({ localStorageKey: "theme" })
  const logout = useAuthStore(store => store.logout)
  const user = useAuthStore(store => store.user)
  const userName = `${user?.firstName} ${user?.lastName}`
  const email = user?.email

  const themeOptions = [
    {
      image: LightTheme,
      label: "Light",
    },
    {
      image: DarkTheme,
      label: "Dark",
    },
    {
      image: SystemTheme,
      label: "System",
    },
  ]

  const handleSignOut = () => {
    // Clear localStorage auth tokens
    logout();
    
    // Redirect to sign-in page
    window.location.href = '/sign-in';
    
    // Add a slight delay before attempting to clear OAuth state
    setTimeout(() => {
      // Try to clear Google's OAuth state by navigating to the Google account logout page in a hidden iframe
      const iframe = document.createElement('iframe');
      iframe.style.display = 'none';
      iframe.src = 'https://accounts.google.com/logout';
      document.body.appendChild(iframe);
      
      // Remove the iframe after a moment
      setTimeout(() => {
        document.body.removeChild(iframe);
      }, 1000);
    }, 100);
  }

  return (
    <Space
      direction='vertical'
      style={{ display: "flex" }}
      split={<Divider type='horizontal' className={"profile-divider"} />}
    >
      <Space className={"profile-info"} direction='vertical'>
        <Row className={"profile-plan"}>Basic</Row>
        <Space direction='vertical'>
          <Paragraph className={"profile-name"}>{userName}</Paragraph>
          <Paragraph className={"profile-email"}>{email}</Paragraph>
        </Space>
      </Space>

      <Row>
        <Row className={"profile-settings"}>
          <Radio.Group
            name={"theme"}
            className={"theme-options"}
            onChange={event => {
              setTernaryDarkMode(event.target.value.toLowerCase() as TernaryDarkMode)
            }}
            value={ternaryDarkMode}
          >
            {themeOptions.map(theme => (
              <Radio key={theme.label} value={theme.label.toLowerCase()} name={theme.label} className={"theme-option"}>
                <Row className={"option"}>
                  <Row className={"theme-option-image"}>
                    <Image src={theme.image} preview={false} />
                  </Row>
                  <Paragraph className={"theme-option-label"}>{theme.label}</Paragraph>
                </Row>
              </Radio>
            ))}
          </Radio.Group>
        </Row>

        <Divider type='horizontal' style={{ margin: "16px 0 6px" }} className={"profile-divider"} />

        <Row className={"profile-buttons"}>
          <NavLink to={"/privacy-policy"} className={"privacy-policy-link"}>
            <Image src={PrivacyPolicyIcon} preview={false} />
            Privacy Policy
          </NavLink>
          <Divider type='horizontal' style={{ margin: "6px 0" }} className={"profile-divider"} />
          <NavLink to="/settings" className={"privacy-policy-link"}>
            <Image src={PrivacyPolicyIcon} preview={false} />
            Settings
          </NavLink>
          <Divider type='horizontal' style={{ margin: "6px 0" }} className={"profile-divider"} />
          <Button
            className={"sign-out"}
            icon={<Image src={SignOutIcon} preview={false} />}
            btnText={"Sign Out"}
            onClick={handleSignOut}
          />
        </Row>
      </Row>
    </Space>
  )
}

export default Profile
